<template>
  <div class="mergeMemory">
    <myTitle style="margin-bottom:3px" :til="'合并'+merage"></myTitle>
    <div class="main">
      <header>
        <el-form :inline="true" :model="formInline" class="form1">
          <el-form-item label="语言对" prop="name">
            <el-col :span="11">
              <el-select v-model="formInline.sourceLang" placeholder="源语言" @change="changeSourceLang">
                <el-option label="全部语言" value></el-option>
                <el-option v-for="(item,index) in LangList" :key="index" :label="item.sourceLangName"
                  :value="item.sourceLang" :disabled="item.status=='0'"></el-option>
              </el-select>
            </el-col>
            <el-col class="line" :span="2">
              <i class="el-icon-right"></i>
            </el-col>
            <el-col :span="11">
              <el-select v-model="formInline.targetLang" placeholder="目标语言" @change="changeTargetLang">
                <el-option label="全部语言" value></el-option>
                <el-option v-for="(item,index) in LangList2" :key="index" :label="item.targetLangName"
                  :value="item.targetLang" :disabled="item.status=='0'"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </el-form>
      </header>
      <template>
        <div style="overflow: auto;height:100%">
          <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width:100%"
            @selection-change="handleSelectionChange" @select-all="selectAll" v-loading="loading">
            <template slot="empty">
              <div id="notDate">
                <img src="../../assets/imgs/memory/no_data.png" alt />
                <p>暂无数据，快去创建吧</p>
              </div>
            </template>
            <el-table-column align="center" type="selection" :selectable="checkSelectable" min-width="10">
            </el-table-column>
            <el-table-column prop="name" label="库名" min-width="10" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" prop="langDesc" label="语言对" min-width="10" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column align="center" prop="domainName" label="领域" min-width="10" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column align="center" prop="sentCount" label="数量" min-width="10" :show-overflow-tooltip="true">
            </el-table-column>
          </el-table>
        </div>
      </template>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" ref="form">
        <el-form-item :label="'合并'+merage+'名称'" prop="name">
          <el-input v-model="formInline.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="领域" prop="domainCode">
          <el-select v-model="formInline.domainCode" placeholder="请选择领域" @change="DomainChange">
            <el-option v-for="(item,index) in domainList" :key="index" :label="item.dataDesc" :value="item.dataKey">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="but">
        <button class="themeCallBut" @click="backtrack">取消</button>
        <button class="themeGoBut" @click="resetForm('form')">合并</button>
      </div>
    </div>
  </div>
</template>

<script>
import myTitle from "@/common/title.vue";

export default {
  name: "mergeMemory",
  // beforeRouteEnter(to, from, next) {
  //   // 侧边栏样式
  //   if (to.query.merage == "术语库") {
  //     setTimeout(() => {
  //       document.getElementById("termBank").parentNode.classList.add("current");
  //       //   this.tableUrl = "/api/v1/term/getTransTermLibList";
  //       //   this.merageUrl = "/api/v1/memory/mergeTransMemoryLib"
  //     }, 20);
  //   }
  //   if (to.query.merage == "记忆库") {
  //     setTimeout(() => {
  //       document
  //         .getElementById("memoryBank")
  //         .parentNode.classList.add("current");
  //       //   this.tableUrl = "/api/v1/memory/getTransMemoryLibList";
  //       // this.merageUrl = "/api/v1/term/mergeTransTermLib"
  //     }, 20);
  //   }
  //   next();
  // },

  // beforeRouteLeave(to, from, next) {
  //   // 导航离开该组件的对应路由时调用
  //   // 可以访问组件实例 `this`
  //   if (from.query.merage) {
  //     document
  //       .getElementById("termBank")
  //       .parentNode.classList.remove("current");
  //     document
  //       .getElementById("memoryBank")
  //       .parentNode.classList.remove("current");
  //   }
  //   next();
  // },
  data () {
    return {
      tableData: [],
      multipleSelection: [], // 存储选中的数组
      formInline: {
        sourceLang: "",
        targetLang: "",
        domainCode: "",
        domainName: "",
        name: "",
        langDesc: "",
        idList: []
      },
      merage: "",
      LangList: "",
      LangList2: "",
      qqq: "",
      domainList: "",
      tableUrl: "",
      merageUrl: "",
      loading: true,
      clearselect: false
      // rules: {
      //   name: [
      //     { required: true, message: "请输入名称", trigger: "blur" },
      //     { min: 1, max: 15, message: "长度不超过16个字符", trigger: "blur" }
      //   ],
      //   domainCode: [
      //     { required: true, message: "请选择领域", trigger: "change" }
      //   ]
      // }
    };
  },
  components: {
    myTitle
  },
  created () {
    if (this.$route.query.merage === "记忆库") {
      this.tableUrl = "/api/v1/memory/queryTransMemoryLibList";
      this.merageUrl = "/api/v1/memory/mergeTransMemoryLib";
    } else {
      this.tableUrl = "/api/v1/term/queryTransTermLibList";
      this.merageUrl = "/api/v1/term/mergeTransTermLib";
    }
    this.merage = this.$route.query.merage;
    this.getLangList("1"); // 获取源语言
    this.getTransMemoryLibList(); // 默认加载 中>英
    this.getDomainList();
  },
  computed: {
    //   qqq:function(){
    //     //   alert(this.qqq)
    //     //   this.formInline
    //     get () {
    //        return this.message + 'world'
    //     }
    //     set () {
    //     }
    //   }
  },
  mounted () {
    // this.formInline.sourceLang = "eng";
    // this.formInline.targetLang = "chn";
    this.loading = false;
  },
  methods: {
    // 返回上一页
    backtrack () {
      this.$router.go(-1);
    },
    // 源语言事件
    changeSourceLang (query) {
      // this.formInline.sourceLang = query;
      if (query == 0) {
        this.getTransMemoryLibList();
      }
      // this.getLangList()
      this.getLangList("2", query); // 获取语言对  目标语言
      this.formInline.targetLang = "";
      this.getTransMemoryLibList(query);
    },
    // 目标语言事件
    changeTargetLang (query) {
      // this.formInline.targetLang = query;
      // this.getLangList("1", query); // 获取语言对  源语言
      this.getTransMemoryLibList(this.formInline.sourceLang, query);
    },
    resetForm (name) {
      if (this.formInline.idList.length < 2) {
        this.$message.closeAll();
        this.$message({
          message: `请选择两条或两条以上${this.merage}`,
          type: "warning"
        });
        return;
      }
      if (!this.detection(this.formInline.name.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "") || "")) {
        return;
      }
      if (!this.formInline.domainCode) {
        this.$message.closeAll();
        this.$message({
          message: "请选择领域",
          type: "warning"
        });
        return;
      }
      this.merge();
      // this.$refs[name].validate(valid => {
      //   if (valid) {
      //     this.merge();
      //   } else {
      //     return;
      //   }
      // });
    },
    // 合并事件
    merge () {
      var that = this;
      // that.loading = true;
      var sourceLang = this.formInline.sourceLang;
      var targetLang = this.formInline.targetLang;
      var params = this.formInline;
      this.catReq1Service(this.merageUrl, params)
        .then(function (response) {
          if (response.resultCode === "1") {
            that.$router.go(-1);
          }
        })

    },
    // 选择领域事件
    DomainChange (query) {
      let obj = {};
      obj = this.domainList.find(item => {
        return item.dataKey === query; //筛选出匹配数据
      });
      this.formInline.domainName = obj.dataDesc;
    },
    // 获取列表
    getTransMemoryLibList (sourceLang, targetLang) {
      var that = this;
      // console.log(sourceLang, targetLang);
      var params = {
        sourceLang,
        targetLang,
      };
      this.catReq1Service(that.tableUrl, params)
        .then(function (response) {
          if (!response.success) {
            return
          }
          that.tableData = response.result;
          that.loading = false;
        })

    },
    // 获取领域
    getDomainList () {
      var that = this;
      var params = {
        dataType: "trans_domain"
      };
      this.catReq1Service("/api/v1/common/queryOptionList", params)
        .then(function (response) {
          if (!response.success) {
            return
          }
          that.domainList = response.result;
        })

    },
    // 获取语言对
    getLangList (type, params) {
      if (!params && type === "2") {
        return
      }
      var that = this;
      let obj = {
        type: type,
        [type === 1 ? 'targetLang' : 'sourceLang']: params || ""
      };
      for (let propName in obj) {
        if (obj[propName] === "") {
          delete obj[propName];
        }
      }
      this.catReq1Service(
        `/api/v1/common/queryLangList`, obj
      )
        .then(function (response) {
          if (!response.success) {
            return
          }
          if (type === "1") {
            that.LangList = response.result;
          } else {
            that.LangList2 = response.result;
          }
        })

    },
    // 选中事件
    checkSelectable (row, selection) {

      if (this.formInline.idList[0]) {
        return row.langDesc == this.formInline.langDesc;
      } else {
        return true;
      }
    },
    selectAll (selection) {
      if (this.clearselect) {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      if (val.length != 0) {
        this.formInline.langDesc = val[0].langDesc;
        this.formInline.sourceLang = val[0].sourceLang;
        this.getLangList("2", val[0].sourceLang);
        this.formInline.targetLang = val[0].targetLang;
        // this.getTransMemoryLibList(val[0].sourceLang,val[0].targetLang)
        // if (val.length < 2) {
        //   this.getLangList("2", val[0].sourceLang)
        // }
      }
      var arr = [];
      let condition = false;
      val.forEach(item => {
        arr.push(item.id);
        if (item.langDesc != val[0].langDesc) {
          condition = true;
        }
      });
      if (condition) {
        this.$message({
          message: "选择的语言对不一致!",
          type: "warning"
        });
        this.clearselect = true;
        return;
      } else {
        this.clearselect = false;
      }
      this.formInline.idList = arr;
    }
  }
};
</script>
<style lang="less" scoped>
.mergeMemory {
  overflow: hidden;
  height: 100%;
  .main {
    header {
      height: 40px;
    }
    overflow: hidden;
    // width: 1620px;
    height: calc(100% - 73px);
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    // margin-top: 7px;
    padding: 20px;
    padding-right: 30px;
    position: relative;
    .el-form-item {
      margin-bottom: 0px;
    }
    // table样式开始
    #notDate {
      // 暂无数据
      // margin-top: 80px;
      height: 100%;
      img {
        height: 50%;
        width: 50%;
      }
      p {
        line-height: 34px;
      }
    }
    /deep/.el-table--border::after,
    .el-table--group::after {
      width: 0px;
    }

    /deep/.has-gutter {
      tr {
        th {
          border: 0px;
          border-bottom: 1px solid #ebeef5;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: center;
        }
      }
    }
    /deep/.el-table td,
    .el-table th {
      border-right: 1px solid #ebeef5;
      // 修改table行高
      padding: 0px !important;
      height: 46px;
    }
    .el-table td,
    .el-table th {
      padding: 0px;
      border-right: 1px solid #ebeef5;
    }
    .el-table th > .cell {
      text-align: center;
    }
    /deep/.el-table td:nth-child(1) {
      border-left: 1px solid #ebeef5;
    }
    /deep/.el-table td {
      text-align: center;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
    }
    /deep/.el-table td:nth-child(2) {
      text-align: left;
    }
    /deep/.el-table::before {
      height: 0;
    }
    /deep/.el-table--enable-row-hover .el-table__body tr tr tr:hover {
      box-shadow: 0px 1px 6px 0px rgba(102, 102, 102, 0.5);
    }
    /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
      // table 鼠标滑动效果
      background: rgba(210, 210, 210, 1);
    }
    // .el-table td, .el-table th.is-leaf,.el-table--border, .el-table--group{
    //   border-color: black;
    // }
    /deep/.el-table {
      height: 100%;
      overflow-y: auto;
      border: 0px;
      .el-table__body-wrapper {
        height: calc(100% - 242px);
        overflow-y: auto;
      }
    }
    // table样式结束
    .form1 {
      float: left;
      height: 40px;
      /deep/.el-input {
        width: 202px;
        height: 36px;
        border-radius: 4px;
      }
    }
    .el-input__icon {
      line-height: 36px;
    }
    .demo-form-inline {
      position: absolute;
      bottom: 100px;
      left: 50%;
      transform: translate(-50%, 0);
      width: 600px;
      /deep/.el-input {
        width: 202px;
        height: 36px;
        border-radius: 4px;
      }
      /deep/.el-input__inner {
        height: 36px;
      }
      input {
        width: 202px;
        height: 36px;
        border-radius: 4px;
      }
    }
    .but {
      position: absolute;
      bottom: 40px;
      left: 50%;
      transform: translate(-50%, 0);
      button {
        margin: 0 20px;
      }
    }
  }
  .el-icon-right {
    margin: 0 10px;
  }
}
</style>